// Keep only sessions that actually have at least one stored answer.
//
// A Session doc is created the moment the questionnaire page loads — before
// any question is answered — so link previews, reloads, staff checking the
// link, and people who open and leave all produce "empty" sessions with no
// responses. Counting those as respondents inflates the real number.
//
// Matching note: Session docs store the id as `SessionId`, while response
// docs store it as `SessionID` (older docs may only carry `FormID`).
const filterSessionsWithResponses = (sessions, responses) => {
    const sessionList = Array.isArray(sessions) ? sessions : []
    const responseList = Array.isArray(responses) ? responses : []

    const idsWithResponses = new Set()
    responseList.forEach((response) => {
        const id = response?.SessionID || response?.FormID
        if (id) idsWithResponses.add(id)
    })

    return sessionList.filter((session) => idsWithResponses.has(session?.SessionId))
}

export default filterSessionsWithResponses
